// extracted by mini-css-extract-plugin
export default {"indicator":"mhnX5MejZgx4DisqxzqK","current":"N7yEh1Btt3Oxo11Jj9_8"};